@if (job().status === 'Done' || job().status === 'Error') {
  <article
    class="cui-card result-node"
    [class.cui-card--interactive]="job().status === 'Done'"
    [class.result-node--success]="job().status === 'Done'"
    [class.result-node--error]="job().status === 'Error'"
    [attr.role]="job().status === 'Done' ? 'button' : null"
    [attr.tabindex]="job().status === 'Done' ? 0 : null"
    (click)="activate()"
    (keydown.enter)="activate()"
    (keydown.space)="activate()">
    <header class="cui-card__header result-node__header">
      <span class="material-symbols-outlined">{{ presentation(job().status).icon }}</span
      ><strong>{{ job().status === 'Done' ? 'Result' : presentation(job().status).status }}</strong>
    </header>
    <div class="result-node__content">
      @if (job().status === 'Error') {
        <p class="result-node__message">{{ errorMessage() }}</p>
      } @else if (resultData(); as results) {
        <app-timeline-preview [data]="results" [parameters]="parameters()"></app-timeline-preview>
      }
    </div>
  </article>
} @else {
  <article class="cui-card cui-skeleton result-node result-node--waiting">
    <span class="material-symbols-outlined">{{ presentation(job().status).icon }}</span
    ><strong>{{ presentation(job().status).status }}</strong>
  </article>
}
